<template>
    <div class="topbox">
        <div class="top w1260">
            <div class="logo fl"><a href="/" title="广西车便捷数字科技股份有限公司__共享洗车|自助洗车加盟|自助洗车机厂家|车便捷共享洗车服务平台"><img
                        src="/skin/images/logo.png" width="238" height="69"
                        alt="广西车便捷数字科技股份有限公司__共享洗车|自助洗车加盟|自助洗车机厂家|车便捷共享洗车服务平台" /></a></div>
            <div class="nav fl">
                <ul>
                    <li :class="$route.path == '/index' ? 'on' : ''"><a href="/">网站首页</a> <span></span> </li>

                    <li :class="$route.path.indexOf('/a/about') > -1 ? 'on' : ''"> <a href="/a/about/">自助洗车品牌</a> <span></span> </li>

                    <li :class="$route.path.indexOf('/a/anli') > -1 ? 'on' : ''"> <a href="/a/anli/">自助洗车案例</a> <span></span> </li>

                    <li :class="$route.path.indexOf('/a/fangan') > -1 ? 'on' : ''"> <a href="/a/fangan/">合作答疑</a> <span></span> </li>

                    <li :class="$route.path.indexOf('/a/zhishi') > -1 ? 'on' : ''"> <a href="/a/zhishi/">洗车机资讯</a> <span></span> </li>

                    <li :class="$route.path.indexOf('/a/contact') > -1 ? 'on' : ''"> <a href="/a/contact/">联系我们</a> <span></span> </li>

                </ul>
            </div>
            <div class="top_r fl">
                <div class="tel fl wow bounceInDown" data-wow-duration="1s" data-wow-delay=".1s"> <img
                        src="/skin/images/tel_03.jpg" width="174" height="24" /> </div>
                <div class="fl weixin"> <a href="javascript:void(0)"> <img src="/skin/images/ewm.jpg" width="20"
                            height="19" />
                    </a>
                    <div class="ewm_code" style="display: none;"> <img src="/skin/images/weixin.jpg" width="120"
                            height="120">
                    </div>
                </div>
                <div id="login"><a href="https://cbj.chebianjie.com/admin/dist/index.html#/login?redirect=%2Fhome" style="color:#1097fa">合作登陆</a></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigation',
    data() {
        return {
        }
    },
    watch: {
        $route: {
            handler(val, oldval) {
                console.log(this.$route)
                console.log(val);//新路由信息
                console.log(oldval);//老路由信息
            },
            // 深度观察监听
            deep: true
        }
    }
}

</script>

